import { utils } from './utils.js';
import { drawer } from './drawer.js';

class Main {

    constructor() {
    }

    init() {
        this.bootstrap()
        this.typographyElementsBeforeHeading();

        this.learnMore();

        this.footerCTA();

        // iframe inclusion from icims.com is Restricted!
        //
        // var iframes = document.querySelectorAll('.iframe-careers');
        // Array.prototype.forEach.call(iframes, function(el, i) {
        //     console.log( el );
        // });
    }

    bootstrap() {
        // first add raf shim
        // http://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
        window.requestAnimFrame = (function () {
            return window.requestAnimationFrame ||
                window.webkitRequestAnimationFrame ||
                window.mozRequestAnimationFrame ||
                function (callback) {
                    window.setTimeout(callback, 1000 / 60);
                };
        })();
    }

    typographyElementsBeforeHeading() {
        let headings = document.querySelectorAll('.template-layout-default .center-content h1,.template-layout-default .center-content h2, .template-layout-default .center-content h3,.template-layout-default .center-content h4, .template-layout-default .center-content h5,.template-layout-default .center-content h6');
        Array.prototype.forEach.call(headings, function (el, i) {
            var prev = el.previousElementSibling;
            if (prev !== null) {
                switch (prev.localName) {
                    case 'h1':
                    case 'h2':
                    case 'h3':
                    case 'h4':
                    case 'h5':
                    case 'h6':
                        break;
                    default:
                        utils.toggleClass(prev, 'element-before-heading');
                }
            }
        });
    }

    learnMore() {

        let self = this;

        let learnMoreLink = document.querySelector('.resource-link .read-more a');
        if (learnMoreLink == null) {
            return;
        }

        let target = document.querySelector('.card-list.-caqs');
        if (target == null) {
            return;
        }

        learnMoreLink.addEventListener('click', function (e) {
            e.preventDefault();
            self.scrollToCAQ(target);
        });

    }

    /**
     * given target element, attempt to scroll to the element with sticky and/or fixed elements
     * e.g. WordPress admin bar
     */
    scrollToCAQ(element) {

        const self = this;

        const bodyRect = document.body.getBoundingClientRect();
        const elemRect = element.getBoundingClientRect();
        const offset = Math.round(elemRect.top - bodyRect.top);

        // @todo fix this on IE 11
        window.scroll({
            top: offset,
            left: 0,
            behavior: 'smooth'
        });
    }

    /*
     * handle footer call to action area 'Book an Appointment' click
     */
    footerCTA() {

        let self = this;

        let footerCTA = document.querySelector('div.call-to-action');
        if (footerCTA == null) {
            return;
        }
        let bookButton = footerCTA.querySelector('.contact-cta a');
        if (bookButton != null) {
            bookButton.addEventListener('click', function (e) {
                e.preventDefault();
                drawer.resetDrawer();
                utils.addClass(drawer.body, 'js-drawer-open');
                utils.addClass(drawer.drawer, '-open');
                utils.addClass(drawer.drawer, '-centered');
                utils.addClass(drawer.drawer, '-book');
            });
        }

    }

}

// Singleton
export let main = new Main();